// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ResponsiveDialog-modal__IdRMc{width:var(--size-96)}.ResponsiveDialog-bottomSheetContent__a6TjA{padding:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": "ResponsiveDialog-modal__IdRMc",
	"bottomSheetContent": "ResponsiveDialog-bottomSheetContent__a6TjA"
};
export default ___CSS_LOADER_EXPORT___;
